<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file simple-search.vue is part of event_pass_client.dev.             -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - simple-search.vue can not be copied and/or distributed                    -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<template>
    <div class="simple-search container" v-cloak @click="clear()">
        <div class="simple-search-container row justify-content-center">
            <div class="col-sm-8 col-md-6">
                <!-- Create a binding between the searchString model and the text field -->
                <div class="simple-search-container-input">
                    <input class=" simple-search-container-input--element"
                           type="text"
                           v-model="searchString"
                           placeholder="Find an event"/>
                </div>

                <!--<div class="simple-search-container-input&#45;&#45;popular-tags">-->
                    <!--<span class="font-weight-bold">-->
                    <!--Popular searches-->
                    <!--</span>-->
                <!--</div>-->
                <transition-group tag="ul" class="mt-2 simple-search-results" name="article">
                    <!-- Render a li element for every entry in the computed filteredArticles array. -->
                    <li class="article"
                        v-for="article in filteredArticles"
                            :key="article.id">
                        <a class="simple-search-results--item" :href="createLink(article[path.data])">
                            <img :src="article[path.data].images[0]" alt="">
                            <span>{{createTitle(article)}}</span>
                        </a>
                    </li>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
	// add imports here
	import axios from 'axios';
	import {mergeObjectDeep} from '../../../tools/objects.arrays';
	// import {getDate, getTime} from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
	import {createUrlFromData} from '../../../tools/format.data_url';

	/**
     * @link https://snipcart.com/blog/vuejs-transitions-animations
	 */
	export default {
		props: ['content'],
		components: {axios},
		mounted() {
			this.url = this.content.url;
			this.path = mergeObjectDeep(this.path, this.content.path);

			this.readDataSet();

		},
		computed: {
			// A computed property that holds only those articles that match the searchString.
			filteredArticles: function () {
				let _this = this,
					articles_array = this.articles,
					searchString = this.searchString;

				if (!searchString
					|| searchString.length < this.searchLength
				) {
					return [];
				}

				searchString = searchString.trim().toLowerCase();

				articles_array = articles_array.filter(function (item) {
					if (item[_this.path.data].lang[_this.lang].title.toLowerCase().indexOf(searchString) !== -1) {
						return item;
					}
				});

				// Return an array with the filtered data.
				return articles_array;
			}
		},
		/**
		 *
		 * @returns {{searchString: string, articles: Array}}
		 */
		data() {
			return {
				searchPosition: 'middle',
				searchString: "",
				searchLength: 3,
				lang: 'en_GB',
				articles: [],
				params: [],
				url: '',
				path: {
					data: 'event_data'
				}
			}
		},
		methods: {
			clear(){
				this.searchString = '';
            },
			createLink(table_data) {
				return createUrlFromData(table_data, this.path.route);

			},
			createTitle(article) {
				return article[this.path.data].lang[this.lang].title;
			},
			readDataSet() {
				let _this = this;

				axios({
					method: 'get',
					url: _this.url,
					params: this.params

				}).then((response) => {
					if (response.status !== 200) {
						console.error('No response');
					}
					_this.articles = response.data;
				});
			}
		}
	}
</script>

<style scoped>
    .article {
        backface-visibility: hidden;
        z-index: 1;
    }

    /* moving */
    .article-move {
        transition: all 600ms ease-in-out 50ms;
    }

    /* appearing */
    .article-enter-active {
        transition: all 400ms ease-out;
    }

    /* disappearing */
    .article-leave-active {
        transition: all 200ms ease-in;
        position: absolute;
        z-index: 0;
    }

    /* appear at / disappear to */
    .article-enter,
    .article-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/search/simple-search.vue